/**
 * Javascript file for the menu, central page for the business model configurator.
 * @author Adrian Rebmann
 */

import { getCookie, setCookie } from "../../../../util";
import { newBusinessmodel } from "../../../../api";

//Cookie determines if the user has already visited the business model.
const cookie = getCookie("beenAtModel");

export default {
  name: "BMMenu",

  /**
   * The vue instance's data object.
   * @property {boolean} first - It is the first time the user is visiting the business model.
   * @property {boolean} nameActive - The pop-up window to set the name of a new model is active.
   * @property {object} nameValue - The name of the business model.
   */
  data() {
    return {
      first: true,
      nameActive: false,
      nameValue: null
    };
  },

  /**
   * Called after the instance has been created.
   */
  created() {
    //If the user has already been at the model, set first to false.
    if (cookie === "true") {
      this.first = false;
    }
  },

  /**
   * The vue instance's method declaration.
   */
  methods: {
    /**
     * Returns to the previous page.
     */
    goBack() {
      //this.$router.go(-1);
       this.$router.push({
        name: "Welcome"
      });
    },

    /**
     * Indicates that the user has already been at the model.
     */
    setBeenHere() {
      setCookie("beenAtModel", "true", 365);
      location.reload();
    },

    /**
     * Redirects the user to the BMHelp page.
     */
    gotoHelp() {
      this.$router.push({
        name: "BMHelp"
      });
    },

    /**
     * Creates a new business model.
     * Redirects to the canvas' brick page.
     */
    createNew() {
      newBusinessmodel(this.nameValue).then(res => {
        /*this.$router.push({
          name: "BusinessModel",
          params: { hash: res.hash, bmname: res.name }
        });*/
        this.$router.push({
          name: "Brick",
          params: { hash: res.hash, name: "Kundensegment" }
        });
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/company/businessmodel/menu/bmmenu.js